import React from "react";
import { ArrowRight, CalendarCheck2 } from "lucide-react";

function scrollToId(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative bg-white border-b-4 border-black overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 lg:py-32">
        <div className="flex items-center gap-3 mb-8">
          <span className="tag-chip tag-chip-red" data-testid="hero-eyebrow">
            Springtown · TX
          </span>
          <span className="tag-chip">Appointment Only</span>
        </div>

        <h1
          data-testid="hero-headline"
          className="font-heading uppercase text-[3rem] sm:text-7xl lg:text-[8.5rem] leading-[0.88] text-black"
        >
          Springtown&apos;s <br />
          <span className="text-[#FF1F1F]">Pokémon</span> <br />
          Vault.
        </h1>

        <p
          data-testid="hero-subhead"
          className="mt-8 max-w-2xl text-lg sm:text-xl text-black/80 leading-relaxed"
        >
          Rocket Card Shop is an appointment-only TCG shop specializing in
          Pokémon — <strong>Sealed</strong>, <strong>Slabs</strong>, and{" "}
          <strong>Singles</strong>. We buy, sell, and trade with collectors who
          actually love the cards.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4">
          <button
            data-testid="hero-cta-book"
            onClick={() => scrollToId("contact")}
            className="nb-btn-primary"
          >
            <CalendarCheck2 size={22} />
            Book Appointment
          </button>
          <button
            data-testid="hero-cta-browse"
            onClick={() => scrollToId("products")}
            className="nb-btn-ghost"
          >
            Browse Products
            <ArrowRight size={20} />
          </button>
        </div>

        <div className="mt-16 grid grid-cols-3 max-w-xl gap-6">
          <div data-testid="hero-stat-1">
            <div className="font-heading text-5xl text-[#FF1F1F] leading-none">3</div>
            <div className="font-mono text-xs uppercase tracking-widest mt-2 font-bold">
              Categories
            </div>
          </div>
          <div data-testid="hero-stat-2">
            <div className="font-heading text-5xl text-black leading-none">1:1</div>
            <div className="font-mono text-xs uppercase tracking-widest mt-2 font-bold">
              Private Visits
            </div>
          </div>
          <div data-testid="hero-stat-3">
            <div className="font-heading text-5xl text-black leading-none">B/S/T</div>
            <div className="font-mono text-xs uppercase tracking-widest mt-2 font-bold">
              Buy · Sell · Trade
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
